import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Currency from '../../../../../../../../../../../components/Currency'
import Money from '../../../../../../../../../../../components/TableCell/components/Money'

import SubTable from './components/SubTable'

import { LOCALE_PREFIX } from '../../constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
@injectIntl
export default class Tables extends Component {
    static propTypes = {
        data: PropTypes.array,
        handleTableChange: PropTypes.func.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        pagination: PropTypes.object,
        sorted: PropTypes.array,
    }

    onTableChange = (changeData) => {
        const { handleTableChange } = this.props

        handleTableChange(changeData)
    }

    renderSubComponent = (subComponentData) => (
        <div className={'sub-component-content'}>
            <SubTable data={_.get(subComponentData, 'row.original.detail', {})} />
        </div>
    )

    render() {
        const { data, pagination, sorted, isLoading, intl } = this.props

        return (
            <div className={'grants-tables-container'}>
                <FilterTable
                    id={'grants-table'}
                    itemIdentifier={'projectId'}
                    data={data ?? []}
                    SubComponent={this.renderSubComponent}
                    columnsDefinition={[
                        {
                            accessor: 'projectName',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.projectName` }),
                        },
                        {
                            accessor: 'drawnAmount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.pumped` }),
                            sortable: true,
                            style: { textAlign: 'right' },
                            width: 150,
                            Cell: (value) => (
                                <Money value={_.get(value, 'value')} emptyValue={'-'} showCurrency={false} />
                            ),
                        },
                        {
                            accessor: 'drawnAmount.currency',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.currency` }),
                            style: { textAlign: 'left' },
                            width: 75,
                            Cell: ({ value }) => <Currency currency={value || 'CZK'} />,
                        },
                        {
                            accessor: 'releasedAmount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.released` }),
                            sortable: true,
                            style: { textAlign: 'right' },
                            width: 150,
                            Cell: (value) => (
                                <Money value={_.get(value, 'value')} emptyValue={'-'} showCurrency={false} />
                            ),
                        },
                        {
                            accessor: 'releasedAmount.currency',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.currency` }),
                            style: { textAlign: 'left' },
                            width: 75,
                            Cell: ({ value }) => <Currency currency={value || 'CZK'} />,
                        },
                        {
                            accessor: 'projectNumber',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.projectNumber` }),
                            width: 200,
                        },
                        {
                            accessor: 'signDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.contractDate` }),
                            sortable: true,
                            width: 150,
                            Cell: (value) => <CustomDate date={_.get(value, 'value.value', '')} precision={'days'} />,
                        },
                    ]}
                    loading={isLoading}
                    settings={{
                        pagination,
                        sorted,
                    }}
                    onTableChange={this.onTableChange}
                    selectable={false}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                    }}
                    expandOnRowClick
                />
            </div>
        )
    }
}
